/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.FinancialIndicatorDataFilter = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The FinancialIndicatorDataFilter model module.
   * @module model/FinancialIndicatorDataFilter
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>FinancialIndicatorDataFilter</code>.
   * @alias module:model/FinancialIndicatorDataFilter
   * @class
   */
  var exports = function() {
    var _this = this;








  };

  /**
   * Constructs a <code>FinancialIndicatorDataFilter</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/FinancialIndicatorDataFilter} obj Optional instance to populate.
   * @return {module:model/FinancialIndicatorDataFilter} The populated <code>FinancialIndicatorDataFilter</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
      if (data.hasOwnProperty('CompanyID')) {
        obj['CompanyID'] = ApiClient.convertToType(data['CompanyID'], 'Integer');
      }
      if (data.hasOwnProperty('IndicatorID')) {
        obj['IndicatorID'] = ApiClient.convertToType(data['IndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('MarketScopeTypeID')) {
        obj['MarketScopeTypeID'] = ApiClient.convertToType(data['MarketScopeTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('BusinessID')) {
        obj['BusinessID'] = ApiClient.convertToType(data['BusinessID'], 'String');
      }
      if (data.hasOwnProperty('StartYear')) {
        obj['StartYear'] = ApiClient.convertToType(data['StartYear'], 'Integer');
      }
      if (data.hasOwnProperty('EndYear')) {
        obj['EndYear'] = ApiClient.convertToType(data['EndYear'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;
  /**
   * @member {Integer} CompanyID
   * @default 0
   */
  exports.prototype['CompanyID'] = 0;
  /**
   * @member {Integer} IndicatorID
   * @default 0
   */
  exports.prototype['IndicatorID'] = 0;
  /**
   * @member {Integer} MarketScopeTypeID
   * @default 0
   */
  exports.prototype['MarketScopeTypeID'] = 0;
  /**
   * @member {String} BusinessID
   * @default ''
   */
  exports.prototype['BusinessID'] = '';
  /**
   * @member {Integer} StartYear
   * @default 0
   */
  exports.prototype['StartYear'] = 0;
  /**
   * @member {Integer} EndYear
   * @default 0
   */
  exports.prototype['EndYear'] = 0;



  return exports;
}));


